import axios from 'axios';
import { supabase } from './supabaseClient';
import config from './config';

const api = axios.create({
  baseURL: config.API_BASE,
});

// Request interceptor to add the Supabase auth token to every request
api.interceptors.request.use(
  async (config) => {
    const { data: { session } } = await supabase.auth.getSession();

    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    }

    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

export default api;

// Plaid helpers (backend-only Plaid calls)
export const createPlaidLinkToken = async ({ itemId } = {}) => {
  const body = itemId ? { item_id: itemId } : {};
  const response = await api.post('/plaid/link-token', body);
  return response.data;
};

export const exchangePlaidPublicToken = async (publicToken, { metadata, itemId } = {}) => {
  const response = await api.post('/plaid/exchange-public-token', {
    public_token: publicToken,
    metadata: metadata || undefined,
    item_id: itemId || undefined
  });
  return response.data;
};

export const completePlaidUpdate = async (itemId) => {
  const response = await api.post('/plaid/update-complete', { item_id: itemId });
  return response.data;
};

// SMS budget-notification helpers (mounted under /api on the backend)
export const getSmsPreferences = async (clientId) => {
  const response = await api.get(`/api/clients/${clientId}/sms-preferences`);
  return response.data;
};

export const updateSmsPreferences = async (clientId, preferences) => {
  const response = await api.put(`/api/clients/${clientId}/sms-preferences`, preferences);
  return response.data;
};

export const previewBudgetSms = async (clientId, month) => {
  const response = await api.post(`/api/admin/clients/${clientId}/send-budget-sms-preview`, { month });
  return response.data;
};

export const sendBudgetSms = async (clientId, { month, message } = {}) => {
  const response = await api.post(`/api/admin/clients/${clientId}/send-budget-sms`, { month, message });
  return response.data;
};

export const getSmsLogs = async (clientId, limit = 10) => {
  const response = await api.get(`/api/admin/clients/${clientId}/sms-logs`, { params: { limit } });
  return response.data;
};

// Career job matches: monthly benchmark postings the client answers yes/no to
export const getCareerMatches = async (clientId) => {
  const response = await api.get(`/api/clients/${clientId}/career-matches`);
  return response.data;
};

export const respondToCareerMatch = async (clientId, matchId, { decision, reasons } = {}) => {
  const response = await api.put(`/api/clients/${clientId}/career-matches/${matchId}`, { decision, reasons });
  return response.data;
};
